import { ShipmentStatus } from '#/shared/api/generated/shipment/models'
import type { ShipmentDetail } from '#/shared/api/generated/shipment/models'

import { SHIPMENT_STAGES } from '../model/stages'

/** Only a New Order can go back to Quotes, and only while nothing is live on a
 *  loadboard — `dispatches` carries active listings only, so any entry means an
 *  active dispatch. Orders further along walk back to New Order via mark-as
 *  first. */
export function canBackToQuote(shipment: ShipmentDetail | undefined): boolean {
  if (!shipment) return false
  return (
    shipment.stage === SHIPMENT_STAGES.ORDER &&
    shipment.status === ShipmentStatus.order &&
    (shipment.dispatches ?? []).length === 0
  )
}
